export var homeData = {
  //https://uk.hotels.com/go?format=json
  "/go": {
    "data": {
      "page": {
        "html": {
          "lang": "en-GB",
          "langdir": "LTR",
          "locale": "en_GB",
          "attributes": {
            "xmlns:fb": "http://www.facebook.com/2008/fbml"
          }
        },
        "head": {
          "title": "Go Guides - So many places, so little time...",
          "links": [{
            "href": "https://uk.hotels.com/go",
            "rel": "canonical"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "x-default",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-ES",
            "rel": "alternate"
          }, {
            "href": "https://sv.hotels.com/go",
            "hreflang": "sv-SE",
            "rel": "alternate"
          }, {
            "href": "https://jp.hotels.com/go",
            "hreflang": "ja-JP",
            "rel": "alternate"
          }, {
            "href": "https://kr.hotels.com/go",
            "hreflang": "ko-KR",
            "rel": "alternate"
          }, {
            "href": "https://www.hoteles.com/go",
            "hreflang": "es-MX",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr-CA",
            "rel": "alternate"
          }, {
            "href": "https://zh.hotels.com/go",
            "hreflang": "zh-HK",
            "rel": "alternate"
          }, {
            "href": "https://tw.hotels.com/go",
            "hreflang": "zh-TW",
            "rel": "alternate"
          }, {
            "href": "https://www.hoteis.com/go",
            "hreflang": "pt-BR",
            "rel": "alternate"
          }, {
            "href": "https://de.hotels.com/go",
            "hreflang": "de-DE",
            "rel": "alternate"
          }, {
            "href": "https://da.hotels.com/go",
            "hreflang": "da-DK",
            "rel": "alternate"
          }, {
            "href": "https://fi.hotels.com/go",
            "hreflang": "fi-FI",
            "rel": "alternate"
          }, {
            "href": "https://it.hotels.com/go",
            "hreflang": "it-IT",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr-FR",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-US",
            "rel": "alternate"
          }, {
            "href": "https://ca.hotels.com/go",
            "hreflang": "en-CA",
            "rel": "alternate"
          }, {
            "href": "https://uk.hotels.com/go",
            "hreflang": "en-GB",
            "rel": "alternate"
          }, {
            "href": "https://no.hotels.com/go",
            "hreflang": "no-NO",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-LA",
            "rel": "alternate"
          }, {
            "href": "https://au.hotels.com/go",
            "hreflang": "en-AU",
            "rel": "alternate"
          }, {
            "href": "https://sg.hotels.com/go",
            "hreflang": "en-SG",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-TH",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-AS",
            "rel": "alternate"
          }, {
            "href": "https://nz.hotels.com/go",
            "hreflang": "en-NZ",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-MY",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-MX",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-CN",
            "rel": "alternate"
          }, {
            "href": "https://in.hotels.com/go",
            "hreflang": "en-IN",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-ZA",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-KR",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-JP",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-IL",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-HK",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-TW",
            "rel": "alternate"
          }, {
            "href": "https://ie.hotels.com/go",
            "hreflang": "en-IE",
            "rel": "alternate"
          }, {
            "href": "https://ph.hotels.com/go",
            "hreflang": "en-PH",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-VN",
            "rel": "alternate"
          }, {
            "href": "https://www.hotels.com/go",
            "hreflang": "en-ID",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-GT",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-BO",
            "rel": "alternate"
          }, {
            "href": "https://co.hoteles.com/go",
            "hreflang": "es-CO",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-GY",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-PA",
            "rel": "alternate"
          }, {
            "href": "https://ar.hoteles.com/go",
            "hreflang": "es-AR",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-CR",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-VE",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-HN",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-UY",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-SV",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-PY",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-CL",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-EC",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-US",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-NI",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-PE",
            "rel": "alternate"
          }, {
            "href": "https://es.hoteles.com/go",
            "hreflang": "es-BZ",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr-BE",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr-GF",
            "rel": "alternate"
          }, {
            "href": "https://fr.hotels.com/go",
            "hreflang": "fr-CH",
            "rel": "alternate"
          }, {
            "href": "https://de.hotels.com/go",
            "hreflang": "de",
            "rel": "alternate"
          }, {
            "href": "https://ch.hotels.com/go",
            "hreflang": "de-CH",
            "rel": "alternate"
          }, {
            "href": "https://at.hotels.com/go",
            "hreflang": "de-AT",
            "rel": "alternate"
          }, {
            "href": "https://de.hotels.com/go",
            "hreflang": "de-BE",
            "rel": "alternate"
          }, {
            "href": "https://it.hotels.com/go",
            "hreflang": "it",
            "rel": "alternate"
          }, {
            "href": "https://it.hotels.com/go",
            "hreflang": "it-CH",
            "rel": "alternate"
          }, {
            "href": "https://kr.hotels.com/go",
            "hreflang": "ko",
            "rel": "alternate"
          }, {
            "href": "https://jp.hotels.com/go",
            "hreflang": "ja",
            "rel": "alternate"
          }],
          "metas": [{
            "name": "title",
            "content": "Go Guides - So many places, so little time..."
          }, {
            "name": "keywords",
            "content": ""
          }, {
            "name": "description",
            "content": "Go Guides is produced by a team of passionate travel professionals with the aim to help you plan the right trip without fuss, and hopefully, have a little fun along the way. Covering exciting destinations across the world, we’ve worked hard to develop concise travel guides that detail what you need to know to make your next"
          }, {
            "name": "theme-color",
            "content": "#ffffff"
          }, {
            "content": "105208249622845",
            "property": "fb:app_id"
          }, {
            "content": "website",
            "property": "og:type"
          }, {
            "content": "Go Guides - So many places, so little time...",
            "property": "og:title"
          }, {
            "content": "Go Guides is produced by a team of passionate travel professionals with the aim to help you plan the right trip without fuss, and hopefully, have a little fun along the way. Covering exciting destinations across the world, we’ve worked hard to develop concise travel guides that detail what you need to know to make your next",
            "property": "og:description"
          }, {
            "content": "https://a.cdn-hotels.com/gdcs/production96/d882/c8517fca-9882-4ae5-b2b7-8db4a344d926.jpg",
            "property": "og:image"
          }]
        }
      },
      "suggestedLanguages": [],
      "common": {
        "clientToken": "Lzmuo0XzDqJRsxqNEodC-hki4-w.",
        "injected_data": {
          "commonDataBlock": {
            "user": {
              "dossierId": "80454537",
              "loyaltyAccountId": "43777247",
              "sessionId": "m2WB8Vzftc0h0WhXracQ2FJuZQ.caa-77d4f449bf-lzrqh",
              "guid": "60983dcf-9fe8-4006-b289-0431ce01eb92",
              "wrStatus": "WR Member",
              "pos": "HCOM_UK",
              "locale": "en_GB",
              "geolocation": {
                "latitude": "1.29",
                "longitude": "103.86"
              },
              "platformId": "Desktop",
              "clientId": "251426",
              "signInState": "auth",
              "ipAddress": "27.111.209.200",
              "hrwMemberStatus": "member",
              "fcStatus": "connected",
              "newsletterOptInStatus": "notSubscribed",
              "visitorState": "newVisitor",
              "md5email": "3e77e262807b42c5a0f649f18314b25b",
              "existingCustomer": 0,
              "hrwTier": "gold",
              "segments": {},
              "signInMethod": "HoB",
              "loyalty": {
                "nightsToFreeNight": 10,
                "freeNightsAvailable": 1,
                "accountNightsBalance": 10,
                "totalNightsLifetimeEarned": 60,
                "totalNightsLifetimeRedeemed": 50,
                "freeNightUSD": 129.18,
                "freeNightLockedCurrency": 4404.08,
                "currency": "THB"
              },
              "cookieConsentStatus": "User Consented",
              "sha256Email": "60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1",
              "customerId": "1a75d41b-a2e1-44dc-911b-166a903e300d"
            },
            "page": {
              "pageName": "go guides :: home",
              "siteSection": "go guides :: home",
              "random10Alpha": "wv19u0kyba",
              "random10Numeric": "7246220063",
              "currency": "THB",
              "additionalPageInformation2": "go guides :: home",
              "fullURL": "https://uk.hotels.com/go?format=json",
              "requestId": "a2d4528e-3ca8-11ee-b064-822325b54751",
              "dataCentre": "chx"
            },
            "search": {},
            "booking": {
              "bookingError": {},
              "lpas": false
            },
            "marketing": {
              "lastTouchedMarketingCode": "seo.hcom.gb.z.www.google.com",
              "restrictedLastTouch": {
                "marketingCode": "seo.hcom.gb.z.www.google.com",
                "fullMarketingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown"
              },
              "currentUnrestricted": {
                "marketingCode": "seo.hcom.gb.z.www.google.com",
                "fullMarketingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown"
              },
              "currentRestricted": {
                "marketingCode": "Brand",
                "fullMarketingCode": "Brand"
              },
              "fullMarketingTrackingCode": "seo.hcom.gb.z.www.google.com.kwrd=unknown",
              "kwrd": "seo unknown term",
              "h4p": {}
            },
            "property": {},
            "event": {
              "bot": false
            },
            "mvtHistory": {
              "mvts": "128.0.0:138.0.2:236.0.0:265.1.0.i6:945.0.0:1068.1.0.i2:1825.0.0:1871.2.0.i7:1917.0.0:1946.0.0:2089.2.0.i3:2383.2.0.i1:2569.0.0:2594.0.0:2596.0.0:2634.1.0.i10:2760.1.0:2796.0.0.i2:2872.0.0:2927.0.0:2929.0.0.i3:3106.0.0:3277.1.0.i5:3427.0.0:3465.0.0:3891.0.0:3988.1.0.i2:4115.0.0:4154.2.0.i4:4163.0.0:4170.1.0.i3:4247.0.0:4514.1.0.i1:4532.1.0.i4:4583.0.0:4596.0.0:4612.1.0.i1:4983.0.0:365.2.0.i117:376.0.0.i0:555.10.0.i1:785.1.0.i12:904.0.0.i0:972.0.0.i0:1167.0.0.i0:1291.20.0.i21:1292.6.0.i9:1293.0.0.i37:1294.24.0.i36:1366.0.0.i0:1439.1.0.i7:2176.1.0.i45:2638.0.0.i0:2768.0.0.i0:2791.0.0.i2:3249.0.0.i0:3664.0.0.i0:3736.0.0.i0:3822.0.0.i0:4178.0.0.i0:4200.0.0.i0:4290.0.0.i0:4440.2.0.i5:4592.0.0.i0:4678.0.0.i1:4725.0.0.i1:4793.1.0.i1:4794.0.0.i38:4824.1.0.i5:4827.1.0.i1:4828.1.0.i5:4869.0.0.i1:4935.0.0.i1:4937.0.0.i0:4952.1.0.i50:4953.1.0.i47:4956.1.0.i66:4961.0.0.i1:4964.1.0.i2:4992.0.0.i1:5003.1.0.i8:5037.0.0.i0:5073.0.0.i1:5104.0.0.i1:5167.0.0.i1:5184.0.0.i1:5227.1.0.i3:5234.0.0.i1:5236.1.0.i2:5274.0.0.i0:5277.0.0.i1:5302.0.0.i0:5342.0.0.i0:5349.0.0.i1:5358.0.0.i1:5571.1.0.i2:5658.0.0.i0:5663.0.0.i0:5664.0.0.i1:5687.0.0.i1:5695.0.0.i1:5756.0.0.i1:5758.0.0.i1:5759.0.0.i1:5760.0.0.i1:5775.1.0.i3:5826.0.0.i1:5843.0.0.i1:5845.1.0.i2:5940.0.0.i1:5971.0.0.i1:5979.0.0.i0:6033.1.0.i9:6039.0.0.i1:6041.1.0.i2:6046.1.0.i3:6171.2.0.i16:6184.0.0.i0:6205.0.0.i0:6206.0.0.i0:6232.0.0.i0:6242.0.0.i0:6244.0.0.i0:6246.0.0.i0:6271.0.0.i1:6299.0.0.i0:6357.1.0.i0:6369.2.0.i5:6370.1.0.i4:6388.0.0.i0:6425.2.0.i0:6439.0.0.i0:6440.1.0.i1:6442.0.0.i0:6451.0.0.i0:6494.2.0.i0:6532.0.0.i1:6544.0.0.i0:6549.0.0.i0:6550.0.0.i0:6553.1.0.i5:6667.0.0.i0:6690.0.0.i0:6710.0.0.i0:6725.8.0.i2:6726.2.0.i2:6727.0.0.i0:6728.0.0.i0:6751.0.0.i0:6755.1.0.i2:6761.0.0.i0:6775.0.0.i0:6779.0.0.i0:6807.1.0.i1:6859.3.0.i0:6866.0.0.i0:6874.0.0.i0:6907.0.0.i0:6909.0.0.i0:6913.0.0.i0:6927.0.0.i0:6938.1.0.i2:6939.1.0.i2:6940.0.0.i0:6941.0.0.i0:6942.1.0.i2:6944.1.0.i2:6946.0.0.i0:6947.1.0.i2:6959.2.0.i20:6966.1.0.i19:7004.0.0.i0:7015.1.0.i7:7031.0.0.i0:7036.0.0.i0:7064.0.0.i7:7066.0.0.i0:7078.0.0.i0:7079.1.0.i3:7080.0.0.i0:7088.0.0.i0:7108.0.0.i0:7115.0.0.i0:7132.0.0.i0:7144.1.0.i3:7145.1.0.i2:7146.0.0.i0:7148.0.0.i0:7157.0.0.i0:7192.1.0.i7:7197.0.0.i0:7214.0.0.i0:7215.1.0.i9:7238.0.0.i0:7280.1.0.i3:7284.0.0.i0:7296.9.0.i30:7305.0.0.i0:7306.2.0.i2:7308.0.0.i0:7327.0.0.i0:7334.1.0.i1:7343.1.0.i5:7353.0.0.i0:7360.1.0.i1:7362.1.0.i32:7368.1.0.i2:7384.0.0.i0:7385.0.0.i0:7395.3.0.i9:7402.1.0.i7:7404.0.0.i0:7414.1.0.i2:7436.0.0.i0:7440.0.0.i0:7450.0.0.i0:7451.0.0.i0:7484.3.0.i3:7500.0.0.i0:7501.0.0.i0:7527.0.0.i0:7550.0.0.i0:7552.1.0.i23:7561.3.0.i84:7576.0.0.i0:7603.0.0.i0:7605.1.0.i0:7625.0.0.i0:7634.0.0.i0:7635.0.0.i0:7660.1.0.i1:7666.0.0.i0:7696.1.0.i0:7700.0.0.i0:7715.0.0.i0:7740.3.0.i11:7741.0.0.i0:7763.0.0.i0:7765.2.0.i5:7787.0.0.i0:7808.0.0.i0:7821.0.0.i0:7825.0.0.i0:7832.2.0.i3:7844.0.0.i0:7858.0.0.i0:7861.4.0.i26:7865.0.0.i0:7867.0.0.i0:7870.0.0.i0:7871.0.0.i0:7878.0.0.i2:7890.1.0.i1:7895.0.0.i0:7896.1.0.i0:7899.0.0.i0:7912.0.0.i0:7913.0.0.i0:7937.0.0.i0:7947.0.0.i0:7950.0.0.i0:7983.0.0.i0:7990.0.0.i0:7992.2.0.i12:8001.0.0.i0:8017.0.0.i0:8026.0.0.i0:8027.2.0.i3:8033.0.0.i0:8037.0.0.i0:8039.0.0.i0:8049.0.0.i0:8056.0.0.i0:8072.0.0.i0:8073.0.0.i0:8075.1.0.i2:8092.0.0.i0:8103.0.0.i9:8115.0.0.i17:8121.1.0.i2:8130.1.0.i0:8141.1.0.i0:8143.1.0.i2:8167.0.0.i0:8171.1.0.i6:8193.0.0.i0:8197.6.0.i7:8210.1.0.i3:8218.0.0.i0:8220.0.0.i0:8227.0.0.i0:8231.2.0.i4:8235.0.0.i0:8248.3.0.i5:8258.2.0.i11:8267.0.0.i0:8272.0.0.i0:8275.1.0.i3:8280.0.0.i0:8287.1.0.i5:8298.0.0.i3:8306.0.0.i0:8326.1.0.i19:8336.2.0.i10:8347.2.0.i13:8348.1.0.i2:8354.1.0.i4:8365.3.0.i4:8385.0.0.i0:8390.2.0.i8:8400.0.0.i0:8405.1.0.i8:8410.3.0.i0:8425.1.0.i6:8426.1.0.i5:8434.0.0.i0:8444.0.0.i0:8448.0.0.i0:8451.0.0.i0:8459.0.0.i0:8477.0.0.i0:8483.0.0.i0:8485.1.0.i6:8494.0.0.i0:8506.0.0.i0:8524.0.0.i0:8536.0.0.i0:8549.2.0.i5:8558.0.0.i0:8591.1.0.i0:8592.0.0.i0:8598.0.0.i0:8605.0.0.i0:8617.0.0.i0:8621.2.0.i2:8624.1.0.i4:8625.2.0.i3:8627.0.0.i0:8637.0.0.i0:8651.2.0.i2:8652.2.0.i2:8656.1.0.i3:8657.0.0.i0:8667.0.0.i0:8671.2.0.i2:8674.1.0.i2:8676.1.0.i2:8683.2.0.i3:8691.1.0.i1:8692.0.0.i0:8693.0.0.i0:8694.1.0.i12:8697.1.0.i6:8698.0.0.i0:8700.0.0.i5:8708.0.0.i0:8711.0.0.i0:8714.1.0.i8:8718.0.0.i0:8738.1.0.i2:8743.1.0.i3:8763.1.0.i3:8769.0.0.i0:8789.1.0.i15:8798.1.0.i2:8817.1.0.i0:8820.0.0.i0:8832.1.0.i0:8867.1.0.i5:8885.0.0.i0:8894.0.0.i0:8900.1.0.i0:8915.0.0.i0:8919.0.0.i0:8928.3.0.i12:8932.2.0.i0:8940.0.0.i0:8941.0.0.i0:8952.0.0.i0:8954.0.0.i0:8955.0.0.i0:8956.0.0.i0:8963.0.0.i0:8967.0.0.i0:8968.0.0.i0:8976.2.0.i6:8987.0.0.i0:8991.1.0.i4:8992.0.0.i0:8996.1.0.i1:9008.0.0.i0:9014.0.0.i0:9023.0.0.i0:9026.0.0.i0:9032.0.0.i0:9035.1.0.i12:9037.1.0.i3:9043.1.0.i8:9048.0.0.i0:9056.0.0.i0:9062.0.0.i0:9068.0.0.i0:9069.0.0.i0:9100.2.0.i3:9121.0.0.i0:9128.0.0.i0:9130.3.0.i4:9134.0.0.i0:9136.0.0.i0:9141.0.0.i0:9145.0.0.i3:9151.0.0.i0:9154.0.0.i0:9155.0.0.i0:9164.0.0.i0:9165.0.0.i0:9166.3.0.i3:9167.0.0.i0:9168.0.0.i0:9169.0.0.i0:9171.0.0.i0:9173.1.0.i2:9174.1.0.i7:9182.0.0.i0:9183.2.0.i7:9197.0.0.i0:9198.3.0.i0:9199.0.0.i0:9201.0.0.i0:9203.0.0.i0:9208.0.0.i0:9214.1.0.i2:9219.2.0.i0:9220.3.0.i9:9229.0.0.i0:9246.0.0.i0:9254.0.0.i0:9255.0.0.i0:9257.1.0.i32:9281.0.0.i0:9282.0.0.i0:9293.1.0.i2:9295.0.0.i0:9296.1.0.i3:9297.0.0.i0:9301.0.0.i0:9306.0.0.i0:9333.1.0.i8:9343.0.0.i0:9347.0.0.i0:9351.0.0.i0:9353.0.0.i0:9363.0.0.i0:9364.0.0.i0:9368.0.0.i0:9385.0.0.i0:9410.0.0.i0:9418.0.0.i0:9419.0.0.i0:9420.2.0.i3:9424.2.0.i1:9427.1.0.i7:9431.0.0.i7:9434.2.0.i3:9439.0.0.i0:9441.2.0.i2:9444.0.0.i0:9455.1.0.i1:9460.1.0.i3:9461.0.0.i0:9469.1.0.i3:9475.1.0.i1:9477.0.0.i0:9483.0.0.i22:9491.1.0.i3:9493.0.0.i0:9501.0.0.i0:9508.0.0.i0:9510.2.0.i2:9513.0.0.i0:9516.2.0.i20:9524.0.0.i0:9528.2.0.i2:9531.3.0.i3:9538.1.0.i0:9549.0.0.i0:9564.0.0.i0:9565.0.0.i0:9566.2.0.i2:9567.2.0.i2:9581.0.0.i0:9583.0.0.i0:9585.2.0.i13:9586.1.0.i1:9588.0.0.i0:9593.0.0.i0:9596.0.0.i0:9601.0.0.i0:9605.2.0.i5:9606.2.0.i13:9613.2.0.i5:9619.2.0.i2:9625.0.0.i0:9629.0.0.i0:9630.1.0.i3:9635.0.0.i0:9656.0.0.i0:9657.0.0.i0:9659.0.0.i0:9660.0.0.i0:9661.0.0.i0:9665.2.0.i5:9669.1.0.i0:9679.1.0.i3:9691.1.0.i6:9692.1.0.i8:9693.0.0.i0:9697.1.0.i1:9699.1.0.i4:9714.0.0.i0:9727.4.0.i3:9728.0.0.i0:9729.1.0.i1:9733.1.0.i16:9737.0.0.i0:9748.0.0.i0:9749.0.0.i0:9750.0.0.i0:9752.0.0.i0:9754.2.0.i5:9757.2.0.i13:9758.1.0.i4:9763.1.0.i2:9771.1.0.i1:9785.0.0.i0:9789.0.0.i0:9792.0.0.i0:9806.2.0.i5:9808.1.0.i2:9810.0.0.i0:9819.1.0.i1:9837.4.0.i4:9854.0.0.i0:9857.0.0.i0:9863.2.0.i2:9864.0.0.i0:9865.0.0.i7:9871.0.0.i0:9876.0.0.i0:9884.5.0.i15:9890.0.0.i0:9892.0.0.i0:9897.0.0.i0:9914.2.0.i2:9924.2.0.i9:9930.0.0.i0:9945.0.0.i0:9948.0.0.i0:9955.0.0.i0:9961.0.0.i0:9962.0.0.i0:9968.0.0.i0:9971.1.0.i14:9974.0.0.i0:9980.0.0.i0:9991.2.0.i5:9992.0.0.i0:9993.0.0.i0:10001.2.0.i2:10002.0.0.i0:10007.2.0.i4:10008.1.0.i2:10013.0.0.i0:10014.1.0.i9:10015.1.0.i5:10025.0.0.i0:10029.1.0.i3:10032.0.0.i0:10033.0.0.i0:10038.1.0.i1:10039.0.0.i0:10040.1.0.i2:10042.1.0.i2:10044.0.0.i0:10049.0.0.i0:10055.0.0.i0:10057.6.0.i6:10058.2.0.i3:10059.0.0.i0:10060.0.0.i0:10061.0.0.i0:10074.0.0.i0:10076.0.0.i0:10077.1.0.i3:10079.0.0.i0:10083.0.0.i0:10085.1.0.i2:10086.0.0.i0:10094.1.0.i4:10101.1.0.i3:10103.1.0.i6:10108.0.0.i0:10110.1.0.i2:10113.0.0.i0:10118.2.0.i3:10121.1.0.i1:10125.1.0.i3:10127.1.0.i2:10135.1.0.i5:10137.0.0.i0:10139.0.0.i0:10142.1.0.i2:10148.1.0.i2:10155.0.0.i0:10173.1.0.i1:10185.0.0.i0:10187.0.0.i0:10192.1.0.i0:10195.0.0.i4:10199.1.0.i2:10200.1.0.i5:10203.1.0.i14:10211.0.0.i0:10212.1.0.i3:10214.0.0.i0:10218.3.0.i1:10220.2.0.i3:10223.1.0.i4:10230.0.0.i0:10231.0.0.i0:10235.0.0.i0:10243.0.0.i0:10246.0.0.i0:10247.1.0.i2:10248.1.0.i5:10251.0.0.i0:10255.0.0.i0:10257.1.0.i2:10259.0.0.i0:10261.1.0.i3:10262.0.0.i0:10264.0.0.i0:10268.0.0.i0:10275.1.0.i2:10276.1.0.i1:10278.1.0.i6:10282.2.0.i6:10286.1.0.i2:10287.0.0.i0:10291.2.0.i4:10299.0.0.i0:10300.1.0.i3:10301.3.0.i2:10306.3.0.i4:10315.1.0.i2:10320.0.0.i0:10323.0.0.i0:10324.0.0.i0:10325.0.0.i0:10326.0.0.i0:10334.0.0.i0:10335.1.0.i1:10336.0.0.i0:10343.2.0.i0:10344.2.0.i0:10345.1.0.i0:10346.0.0.i0:10355.0.0.i0:10361.2.0.i5:10390.2.0.i3:10396.1.0.i2:10397.1.0.i4:10402.1.0.i1:10416.1.0.i1:10423.0.0.i0:10424.0.0.i2:10440.3.0.i2:10443.2.0.i3:10472.0.0.i0:10473.0.0.i0:10482.2.0.i3:10483.0.0.i0:10500.1.0.i5:10517.0.0.i0:10520.0.0.i0:10555.1.0.i1:10565.1.0.i5:10566.3.0.i4:10567.1.0.i2:10569.2.0.i5:10571.5.0.i6|HCOM_UK",
              "athenaMvts": "365.117.2,376.0.0,555.1.10,785.12.1,904.0.0,972.0.0,1167.0.0,1291.21.20,1292.9.6,1293.37.0,1294.36.24,1366.0.0,1439.7.1,2176.45.1,2638.0.0,2768.0.0,2791.2.0,3249.0.0,3664.0.0,3736.0.0,3822.0.0,4178.0.0,4200.0.0,4290.0.0,4440.5.2,4592.0.0,4678.1.0,4725.1.0,4793.1.1,4794.38.0,4824.5.1,4827.1.1,4828.5.1,4869.1.0,4935.1.0,4937.0.0,4952.50.1,4953.47.1,4956.66.1,4961.1.0,4964.2.1,4992.1.0,5003.8.1,5037.0.0,5073.1.0,5104.1.0,5167.1.0,5184.1.0,5227.3.1,5234.1.0,5236.2.1,5274.0.0,5277.1.0,5302.0.0,5342.0.0,5349.1.0,5358.1.0,5571.2.1,5658.0.0,5663.0.0,5664.1.0,5687.1.0,5695.1.0,5756.1.0,5758.1.0,5759.1.0,5760.1.0,5775.3.1,5826.1.0,5843.1.0,5845.2.1,5940.1.0,5971.1.0,5979.0.0,6033.9.1,6039.1.0,6041.2.1,6046.3.1,6171.16.2,6184.0.0,6205.0.0,6206.0.0,6232.0.0,6242.0.0,6244.0.0,6246.0.0,6271.1.0,6299.0.0,6357.0.1,6369.5.2,6370.4.1,6388.0.0,6425.0.2,6439.0.0,6440.1.1,6442.0.0,6451.0.0,6494.0.2,6532.1.0,6544.0.0,6549.0.0,6550.0.0,6553.5.1,6667.0.0,6690.0.0,6710.0.0,6725.2.8,6726.2.2,6727.0.0,6728.0.0,6751.0.0,6755.2.1,6761.0.0,6775.0.0,6779.0.0,6807.1.1,6859.0.3,6866.0.0,6874.0.0,6907.0.0,6909.0.0,6913.0.0,6927.0.0,6938.2.1,6939.2.1,6940.0.0,6941.0.0,6942.2.1,6944.2.1,6946.0.0,6947.2.1,6959.20.2,6966.19.1,7004.0.0,7015.7.1,7031.0.0,7036.0.0,7064.7.0,7066.0.0,7078.0.0,7079.3.1,7080.0.0,7088.0.0,7108.0.0,7115.0.0,7132.0.0,7144.3.1,7145.2.1,7146.0.0,7148.0.0,7157.0.0,7192.7.1,7197.0.0,7214.0.0,7215.9.1,7238.0.0,7280.3.1,7284.0.0,7296.30.9,7305.0.0,7306.2.2,7308.0.0,7327.0.0,7334.1.1,7343.5.1,7353.0.0,7360.1.1,7362.32.1,7368.2.1,7384.0.0,7385.0.0,7395.9.3,7402.7.1,7404.0.0,7414.2.1,7436.0.0,7440.0.0,7450.0.0,7451.0.0,7484.3.3,7500.0.0,7501.0.0,7527.0.0,7550.0.0,7552.23.1,7561.84.3,7576.0.0,7603.0.0,7605.0.1,7625.0.0,7634.0.0,7635.0.0,7660.1.1,7666.0.0,7696.0.1,7700.0.0,7715.0.0,7740.11.3,7741.0.0,7763.0.0,7765.5.2,7787.0.0,7808.0.0,7821.0.0,7825.0.0,7832.3.2,7844.0.0,7858.0.0,7861.26.4,7865.0.0,7867.0.0,7870.0.0,7871.0.0,7878.2.0,7890.1.1,7895.0.0,7896.0.1,7899.0.0,7912.0.0,7913.0.0,7937.0.0,7947.0.0,7950.0.0,7983.0.0,7990.0.0,7992.12.2,8001.0.0,8017.0.0,8026.0.0,8027.3.2,8033.0.0,8037.0.0,8039.0.0,8049.0.0,8056.0.0,8072.0.0,8073.0.0,8075.2.1,8092.0.0,8103.9.0,8115.17.0,8121.2.1,8130.0.1,8141.0.1,8143.2.1,8167.0.0,8171.6.1,8193.0.0,8197.7.6,8210.3.1,8218.0.0,8220.0.0,8227.0.0,8231.4.2,8235.0.0,8248.5.3,8258.11.2,8267.0.0,8272.0.0,8275.3.1,8280.0.0,8287.5.1,8298.3.0,8306.0.0,8326.19.1,8336.10.2,8347.13.2,8348.2.1,8354.4.1,8365.4.3,8385.0.0,8390.8.2,8400.0.0,8405.8.1,8410.0.3,8425.6.1,8426.5.1,8434.0.0,8444.0.0,8448.0.0,8451.0.0,8459.0.0,8477.0.0,8483.0.0,8485.6.1,8494.0.0,8506.0.0,8524.0.0,8536.0.0,8549.5.2,8558.0.0,8591.0.1,8592.0.0,8598.0.0,8605.0.0,8617.0.0,8621.2.2,8624.4.1,8625.3.2,8627.0.0,8637.0.0,8651.2.2,8652.2.2,8656.3.1,8657.0.0,8667.0.0,8671.2.2,8674.2.1,8676.2.1,8683.3.2,8691.1.1,8692.0.0,8693.0.0,8694.12.1,8697.6.1,8698.0.0,8700.5.0,8708.0.0,8711.0.0,8714.8.1,8718.0.0,8738.2.1,8743.3.1,8763.3.1,8769.0.0,8789.15.1,8798.2.1,8817.0.1,8820.0.0,8832.0.1,8867.5.1,8885.0.0,8894.0.0,8900.0.1,8915.0.0,8919.0.0,8928.12.3,8932.0.2,8940.0.0,8941.0.0,8952.0.0,8954.0.0,8955.0.0,8956.0.0,8963.0.0,8967.0.0,8968.0.0,8976.6.2,8987.0.0,8991.4.1,8992.0.0,8996.1.1,9008.0.0,9014.0.0,9023.0.0,9026.0.0,9032.0.0,9035.12.1,9037.3.1,9043.8.1,9048.0.0,9056.0.0,9062.0.0,9068.0.0,9069.0.0,9100.3.2,9121.0.0,9128.0.0,9130.4.3,9134.0.0,9136.0.0,9141.0.0,9145.3.0,9151.0.0,9154.0.0,9155.0.0,9164.0.0,9165.0.0,9166.3.3,9167.0.0,9168.0.0,9169.0.0,9171.0.0,9173.2.1,9174.7.1,9182.0.0,9183.7.2,9197.0.0,9198.0.3,9199.0.0,9201.0.0,9203.0.0,9208.0.0,9214.2.1,9219.0.2,9220.9.3,9229.0.0,9246.0.0,9254.0.0,9255.0.0,9257.32.1,9281.0.0,9282.0.0,9293.2.1,9295.0.0,9296.3.1,9297.0.0,9301.0.0,9306.0.0,9333.8.1,9343.0.0,9347.0.0,9351.0.0,9353.0.0,9363.0.0,9364.0.0,9368.0.0,9385.0.0,9410.0.0,9418.0.0,9419.0.0,9420.3.2,9424.1.2,9427.7.1,9431.7.0,9434.3.2,9439.0.0,9441.2.2,9444.0.0,9455.1.1,9460.3.1,9461.0.0,9469.3.1,9475.1.1,9477.0.0,9483.22.0,9491.3.1,9493.0.0,9501.0.0,9508.0.0,9510.2.2,9513.0.0,9516.20.2,9524.0.0,9528.2.2,9531.3.3,9538.0.1,9549.0.0,9564.0.0,9565.0.0,9566.2.2,9567.2.2,9581.0.0,9583.0.0,9585.13.2,9586.1.1,9588.0.0,9593.0.0,9596.0.0,9601.0.0,9605.5.2,9606.13.2,9613.5.2,9619.2.2,9625.0.0,9629.0.0,9630.3.1,9635.0.0,9656.0.0,9657.0.0,9659.0.0,9660.0.0,9661.0.0,9665.5.2,9669.0.1,9679.3.1,9691.6.1,9692.8.1,9693.0.0,9697.1.1,9699.4.1,9714.0.0,9727.3.4,9728.0.0,9729.1.1,9733.16.1,9737.0.0,9748.0.0,9749.0.0,9750.0.0,9752.0.0,9754.5.2,9757.13.2,9758.4.1,9763.2.1,9771.1.1,9785.0.0,9789.0.0,9792.0.0,9806.5.2,9808.2.1,9810.0.0,9819.1.1,9837.4.4,9854.0.0,9857.0.0,9863.2.2,9864.0.0,9865.7.0,9871.0.0,9876.0.0,9884.15.5,9890.0.0,9892.0.0,9897.0.0,9914.2.2,9924.9.2,9930.0.0,9945.0.0,9948.0.0,9955.0.0,9961.0.0,9962.0.0,9968.0.0,9971.14.1,9974.0.0,9980.0.0,9991.5.2,9992.0.0,9993.0.0,10001.2.2,10002.0.0,10007.4.2,10008.2.1,10013.0.0,10014.9.1,10015.5.1,10025.0.0,10029.3.1,10032.0.0,10033.0.0,10038.1.1,10039.0.0,10040.2.1,10042.2.1,10044.0.0,10049.0.0,10055.0.0,10057.6.6,10058.3.2,10059.0.0,10060.0.0,10061.0.0,10074.0.0,10076.0.0,10077.3.1,10079.0.0,10083.0.0,10085.2.1,10086.0.0,10094.4.1,10101.3.1,10103.6.1,10108.0.0,10110.2.1,10113.0.0,10118.3.2,10121.1.1,10125.3.1,10127.2.1,10135.5.1,10137.0.0,10139.0.0,10142.2.1,10148.2.1,10155.0.0,10173.1.1,10185.0.0,10187.0.0,10192.0.1,10195.4.0,10199.2.1,10200.5.1,10203.14.1,10211.0.0,10212.3.1,10214.0.0,10218.1.3,10220.3.2,10223.4.1,10230.0.0,10231.0.0,10235.0.0,10243.0.0,10246.0.0,10247.2.1,10248.5.1,10251.0.0,10255.0.0,10257.2.1,10259.0.0,10261.3.1,10262.0.0,10264.0.0,10268.0.0,10275.2.1,10276.1.1,10278.6.1,10282.6.2,10286.2.1,10287.0.0,10291.4.2,10299.0.0,10300.3.1,10301.2.3,10306.4.3,10315.2.1,10320.0.0,10323.0.0,10324.0.0,10325.0.0,10326.0.0,10334.0.0,10335.1.1,10336.0.0,10343.0.2,10344.0.2,10345.0.1,10346.0.0,10355.0.0,10361.5.2,10390.3.2,10396.2.1,10397.4.1,10402.1.1,10416.1.1,10423.0.0,10424.2.0,10440.2.3,10443.3.2,10472.0.0,10473.0.0,10482.3.2,10483.0.0,10500.5.1,10517.0.0,10520.0.0,10555.1.1,10565.5.1,10566.4.3,10567.2.1,10569.5.2,10571.6.5"
            }
          }
        },
        "trackingTags": [],
        "adBanner": {
          "adsLoaderUrl": "https://www.uciservice.com/assets/meso-loaders/ads-loader.js",
          "slotConfigurations": [],
          "targetingConfiguration": {
            "mc1": "60983dcf9fe84006b2890431ce01eb92",
            "cmptst": "",
            "d": null,
            "activity": "fb9c4730-a163-4da3-b066-a54107ae5f54",
            "ssl": true
          },
          "variant": null,
          "pageId": null,
          "es5LibraryUrl": "https://www.uciservice.com/assets/meso-loaders/ads-loader.es5.js",
          "libraryUrl": "https://www.uciservice.com/assets/ads/2.0/fb882cc746c927150fee0cc3df4f5e1943f9abe6/expads-hcom-min.js"
        },
        "tracking": {
          "harvesterUrl": "https://apihotels.net/onestream/events/",
          "omniture": {
            "s.channel": "go guides :: home",
            "s.currencyCode": "THB",
            "s.eVar4": "|SI:auth|VS:newVisitor|HCR:member|FC:connected|NS:notSubscribed|TI:gold|SM:HoB|IR:authAccountHolder|",
            "s.eVar13": "251426",
            "s.eVar26": "SG::SINGAPORE:",
            "s.eVar33": "go guides :: home",
            "s.eVar34": "H1871:007.002,H3277:005.001,H4532:004.001,M4869:001.000,M6184:000.000,M7296:030.009,M7561:084.003,M7576:000.000,M8287:005.001,M8448:000.000,M9246:000.000,M9491:003.001,M9991:005.002,M10059:000.000,M10325:000.000",
            "s.eVar41": "THB",
            "s.eVar43": "en_GB|HCOM_UK|uk.hotels.com",
            "s.eVar59": "Desktop|go guides :: home",
            "s.eVar61": "Desktop",
            "s.eVar80": "",
            "s.eVar93": "chx",
            "s.events": "event294,event57",
            "s.pageName": "go guides :: home",
            "s.prop5": "251426",
            "s.prop27": "60983dcf-9fe8-4006-b289-0431ce01eb92",
            "s.prop28": "0",
            "s.prop32": "D=v43",
            "s.prop33": "D=v33",
            "s.prop34": "DestinationDiscoveryApp-",
            "s.prop36": "|SI:auth|VS:newVisitor|HCR:member|FC:connected|NS:notSubscribed|TI:gold|SM:HoB|IR:authAccountHolder|",
            "s.prop37": "1a75d41b-a2e1-44dc-911b-166a903e300d",
            "s.prop38": "ToFree:10|FreeAvail:1|AccBal:10|FreeUSD:129.1800|FreeLock:4404.0800|Curr:THB",
            "s.prop39": "TotalEarned:60|TotalRedeemed:50",
            "s.prop46": "D=v61",
            "s.server": "uk.hotels.com",
            "s.eVar95": "User Consented"
          },
          "omniture_escaped": "<script type=\\\"text/javascript\\\"><!--//--><![CDATA[//><!--\\ns.channel = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20home\\\";s.currencyCode = \\\"THB\\\";s.eVar4 = \\\"\\x5Cx7CSI\\x5Cx3Aauth\\x5Cx7CVS\\x5Cx3AnewVisitor\\x5Cx7CHCR\\x5Cx3Amember\\x5Cx7CFC\\x5Cx3Aconnected\\x5Cx7CNS\\x5Cx3AnotSubscribed\\x5Cx7CTI\\x5Cx3Agold\\x5Cx7CSM\\x5Cx3AHoB\\x5Cx7CIR\\x5Cx3AauthAccountHolder\\x5Cx7C\\\";s.eVar13 = \\\"251426\\\";s.eVar26 = \\\"SG\\x5Cx3A\\x5Cx3ASINGAPORE\\x5Cx3A\\\";s.eVar33 = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20home\\\";s.eVar34 = \\\"H1871\\x5Cx3A007.002,H3277\\x5Cx3A005.001,H4532\\x5Cx3A004.001,M4869\\x5Cx3A001.000,M6184\\x5Cx3A000.000,M7296\\x5Cx3A030.009,M7561\\x5Cx3A084.003,M7576\\x5Cx3A000.000,M8287\\x5Cx3A005.001,M8448\\x5Cx3A000.000,M9246\\x5Cx3A000.000,M9491\\x5Cx3A003.001,M9991\\x5Cx3A005.002,M10059\\x5Cx3A000.000,M10325\\x5Cx3A000.000\\\";s.eVar41 = \\\"THB\\\";s.eVar43 = \\\"en_GB\\x5Cx7CHCOM_UK\\x5Cx7Cuk.hotels.com\\\";s.eVar61 = \\\"Desktop\\\";s.eVar80 = \\\"\\\";s.eVar93 = \\\"chx\\\";s.events = \\\"event294,event57\\\";s.pageName = \\\"go\\x5Cx20guides\\x5Cx20\\x5Cx3A\\x5Cx3A\\x5Cx20home\\\";s.prop5 = \\\"251426\\\";s.prop27 = \\\"60983dcf\\x5Cx2D9fe8\\x5Cx2D4006\\x5Cx2Db289\\x5Cx2D0431ce01eb92\\\";s.prop28 = \\\"0\\\";s.prop32 = \\\"D\\x5Cx3Dv43\\\";s.prop33 = \\\"D\\x5Cx3Dv33\\\";s.prop34 = \\\"DestinationDiscoveryApp\\x5Cx2D\\\";s.prop36 = \\\"\\x5Cx7CSI\\x5Cx3Aauth\\x5Cx7CVS\\x5Cx3AnewVisitor\\x5Cx7CHCR\\x5Cx3Amember\\x5Cx7CFC\\x5Cx3Aconnected\\x5Cx7CNS\\x5Cx3AnotSubscribed\\x5Cx7CTI\\x5Cx3Agold\\x5Cx7CSM\\x5Cx3AHoB\\x5Cx7CIR\\x5Cx3AauthAccountHolder\\x5Cx7C\\\";s.prop37 = \\\"1a75d41b\\x5Cx2Da2e1\\x5Cx2D44dc\\x5Cx2D911b\\x5Cx2D166a903e300d\\\";s.prop38 = \\\"ToFree\\x5Cx3A10\\x5Cx7CFreeAvail\\x5Cx3A1\\x5Cx7CAccBal\\x5Cx3A10\\x5Cx7CFreeUSD\\x5Cx3A129.1800\\x5Cx7CFreeLock\\x5Cx3A4404.0800\\x5Cx7CCurr\\x5Cx3ATHB\\\";s.prop39 = \\\"TotalEarned\\x5Cx3A60\\x5Cx7CTotalRedeemed\\x5Cx3A50\\\";s.prop46 = \\\"D\\x5Cx3Dv61\\\";s.server = \\\"uk.hotels.com\\\";s.eVar95 = \\\"User\\x5Cx20Consented\\\"; if (dio.getObjectByName('dio.util.tracking')) { s.eVar59=dio.util.tracking.responsive('Desktop|go guides :: home'); } ; s.list3 = 'D=v34'; s.t();s.eVar34 = null;\\n  //--><!]]><\\/script>",
          "universal_analytics": {
            "account": "UA-32616238-1",
            "_anonymizeIp": "false",
            "allowLinker": true,
            "enabled": "true",
            "page_view": {
              "PAGE_NAME": "ga(\"set\", \"page\", \"go\\x20guides\\x20\\x3A\\x3A\\x20home\");",
              "USER_ID": "ga(\"set\", \"userId\", \"60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1\");",
              "CID": "ga(\"set\", \"dimension1\", \"251426\");",
              "USER_CONTEXT": "ga(\"set\", \"dimension2\", \"en_GB\\x7CHCOM_UK\\x7Cuk.hotels.com\");",
              "GUID": "ga(\"set\", \"dimension3\", \"60983dcf\\x2D9fe8\\x2D4006\\x2Db289\\x2D0431ce01eb92\");",
              "PROFILE_ID": "ga(\"set\", \"dimension4\", \"1a75d41b\\x2Da2e1\\x2D44dc\\x2D911b\\x2D166a903e300d\");",
              "LOG_IN_STATUS": "ga(\"set\", \"dimension5\", \"Signed\\x20In\");",
              "WELCOME_REWARDS_STATUS": "ga(\"set\", \"dimension6\", \"WR\\x20Member\");",
              "MOBILE_PLATFORM": "ga(\"set\", \"dimension7\", \"DESKTOP\");",
              "RESTRICTED_LAST_TOUCH_MARKETING_CODE": "ga(\"set\", \"dimension14\", \"seo.hcom.gb.z.www.google.com\");",
              "LAST_TOUCH_MARKETING_CODE": "ga(\"set\", \"dimension15\", \"seo.hcom.gb.z.www.google.com\");",
              "SHA_256_EMAIL_ADDRESS": "ga(\"set\", \"dimension65\", \"60b5313ad0ac64f58ab1ea3565a287eb89b38af248ab6d7db59efd8029709ff1\");",
              "FULL_URL": "ga(\"set\", \"dimension80\", \"https\\x3A\\x2F\\x2Fuk.hotels.com\\x2Fgo\\x3Fformat\\x3Djson\");"
            },
            "googleTagManagerId": "",
            "profileId": "1a75d41b-a2e1-44dc-911b-166a903e300d"
          },
          "ensighten": {
            "url": "//nexus.ensighten.com/hotelscom/prod/Bootstrap.js"
          },
          "tag_commander": {
            "container": "//cdn.tagcommander.com/4285/tc_hotels_com_20.js",
            "serverside_pixel": "https://serverside4285.tagcommander.com/21/"
          },
          "unified_data_toolkit": {
            "content": null
          }
        },
        "configuration": {
          "OMNITURE_S_ACCOUNT": "hotelsallprod",
          "OMNITURE_S_LNK_INT_FLTR": "javascript:,hotels.com,hoteis.com,hoteles.com,hotels.cn",
          "OMNITURE_S_SURVEY_ACCOUNT": "hotelsallprod"
        },
        "pointOfSale": {
          "numberSeparators": ",.",
          "brandName": "Hotels.com"
        },
        "user": {
          "firstName": "Wittaya",
          "lastName": "Saekoew"
        }
      },
      "body": {
        "@type": "home",
        "h1": "Go Guides",
        "h2": "So many places, so little time...",
        "introText": "<p>Go Guides is produced by a team of passionate travel professionals with the aim to help you plan the right trip without fuss, and hopefully, have a little fun along the way. Covering exciting destinations across the world, we’ve worked hard to develop concise travel guides that detail what you need to know to make your next trip as fulfilling as possible. Even frequent travellers will find some gems here. All of the&nbsp;must-see landmarks&nbsp;and popular attractions can be found in Go Guides, along with more specific information for different types of holidays. You’ll find advice on the best family&nbsp;beaches, bustling local markets, jaw-dropping sunset vistas, and that’s just scratching the surface.</p><p>You may have a clear idea of where your next adventure lies, or you may be looking for<strong>&nbsp;</strong>inspiration. We try to cater to you too, with some travel guides to spark a bit of wanderlust. Go Guides has been developed to be easy to browse by destination or theme. As much as we try to keep up with the changing realities we’re all faced with, please bear in mind that not all the recommendations will be available. We’re still here to be a trusted guide. After all, holidays don’t have a do-over.</p>",
        "image": {
          "imageUrl": "https://a.cdn-hotels.com/gdcs/production96/d882/c8517fca-9882-4ae5-b2b7-8db4a344d926.jpg"
        },
        "topDestinations": [{
          "name": "London",
          "targetUrl": "/go/england/london?intlid=gghome|topdes",
          "snippetText": "London is the cultural heart of England, housing some of the world’s most famous and popular attractions. A city break means something different to every visitor – some will find a procession of historic palaces and sweeping parks, others a whirl...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production29/d1870/6a5ec560-bb25-11e8-970b-0242ac110006.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "New York",
          "targetUrl": "/go/usa/new-york?intlid=gghome|topdes",
          "snippetText": "New York is an expansive metropolis with virtually endless things to see and do. Many of the city’s famous landmarks are in the Midtown area, where you can take in the view from the top of the Empire State Building...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production164/d1892/abe4516c-de63-4e90-a696-955e0bf194c6.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Paris",
          "targetUrl": "/go/france/paris?intlid=gghome|topdes",
          "snippetText": "Visitors flock to Paris from every corner of the globe for a taste of Europe's resplendent past – whether that means...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production130/d1345/21c02320-9beb-11e8-be36-0242ac110002.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Amsterdam",
          "targetUrl": "/go/netherlands/amsterdam?intlid=gghome|topdes",
          "snippetText": "Amsterdam is a liberal city that boasts some of the world’s most renowned museums – its medieval Old Centre could even...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production101/d1159/354bc7dd-bda4-4383-a36b-4ef2f21c269b.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Manchester",
          "targetUrl": "/go/england/manchester?intlid=gghome|topdes",
          "snippetText": "Manchester revels in its reputation as one of England's coolest, most cosmopolitan cities. It's a vibrant cultural melting pot, with...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production179/d1536/bdfbffe4-6091-4223-9132-182d171df93c.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Dublin",
          "targetUrl": "/go/ireland/dublin?intlid=gghome|topdes",
          "snippetText": "Ireland’s capital, Dublin, has a growing reputation as one of Europe’s most worthwhile destinations due to the sheer number of...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production196/d818/be3d3175-42bb-48ae-8465-c9a103e18003.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Edinburgh",
          "targetUrl": "/go/scotland/edinburgh?intlid=gghome|topdes",
          "snippetText": "Edinburgh enchants first-time visitors with its effortless old-world elegance. Its UNESCO-listed historic centre is a beguiling maze...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production15/d154/b4be76e7-6071-4a32-b105-05d7a80379d0.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Dubai",
          "targetUrl": "/go/united-arab-emirates/dubai?intlid=gghome|topdes",
          "snippetText": "Dubai is a vibrant, multi-cultural city situated on the Arabian Gulf coast of the United Arab Emirates. This glossy...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production81/d94/cf4b5dbc-bbe8-4693-8240-ebec54aaf0de.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Abu Dhabi",
          "targetUrl": "/go/united-arab-emirates/abu-dhabi?intlid=gghome|topdes",
          "snippetText": "Abu Dhabi is the capital of the United Arab Emirates and a remarkable destination in the Middle East. Most of...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production15/d288/4474ed70-d272-41b6-9947-b76204f18fa1.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Birmingham",
          "targetUrl": "/go/england/birmingham?intlid=gghome|topdes",
          "snippetText": "Birmingham is a multi-faceted modern metropolis, where centuries-old churches stand alongside architecturally adventurous mosques, and where a diverse...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production133/d534/20b84927-a8dd-409c-91bf-4c6b28b2a3a5.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Dresden",
          "targetUrl": "/go/germany/dresden?intlid=gghome|topdes",
          "snippetText": "Dresden's celebrated cityscape is a picturesque blend of green gardens and parks, crowned by the spires, domes and towers of...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production80/d1898/44b54c80-a527-11e8-bc7c-0242ac110002.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Corsica",
          "targetUrl": "/go/france/corsica?intlid=gghome|topdes",
          "snippetText": "Corsica is an island in the south-eastern Mediterranean coast of France. Nicknamed the ‘Isle of Beauty’, it’s an excellent...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production8/d220/9eb8a1bc-237d-4cb3-b09f-5f2358264e86.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Branson",
          "targetUrl": "/go/usa/branson?intlid=gghome|topdes",
          "snippetText": "Branson is a popular town in Missouri that’s home to unique attractions like niche museums, natural features and a fountain...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production108/d1245/bc684d29-9bbe-4c52-8358-81fa92b8081f.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Las Vegas",
          "targetUrl": "/go/usa/las-vegas?intlid=gghome|topdes",
          "snippetText": "Las Vegas is a sprawling neon-washed city in the sunny desert state of Nevada. Rightly known as the City...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production4/d301/0e261500-c55c-11e8-825c-0242ac110006.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Sihanoukville",
          "targetUrl": "/go/cambodia/sihanoukville?intlid=gghome|topdes",
          "snippetText": "With its beaches and casinos, Sihanoukville is primarily a tourist attraction, though one with an industrial deepwater port. Because of...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production58/d1017/5b1d8656-bb56-430f-be2f-c0c07c66bbb7.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Buckinghamshire",
          "targetUrl": "/go/england/buckinghamshire?intlid=gghome|topdes",
          "snippetText": "Buckinghamshire, called Bucks by locals, is a South East England ceremonial county offering literary connections, National Trust sites, theme parks...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production143/d109/ceecb796-8bbe-4925-b97c-47338b591b7b.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "Malmö",
          "targetUrl": "/go/sweden/malmo?intlid=gghome|topdes",
          "snippetText": "Malmo is enjoying a resurgence as the economic and cultural powerhouse of the Scania region of South Sweden. The completion...",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production9/d482/99f71ade-8bd5-4646-b0a3-4a5053aaf9a5.jpg",
            "imageAttribution": null
          }
        }],
        "locale": "en_GB",
        "parentPageId": "652ade48-efca-45d6-8090-bf44d0a90035",
        "contentSource": "cit_original",
        "id": 1290906,
        "sharedId": 1290902,
        "urlCorrectionEnabled": true,
        "travelBlog": false,
        "version": 2,
        "countryName": "",
        "cityName": "",
        "destinationName": "",
        "destinationId": null,
        "destinationType": null,
        "categoryCode": null,
        "breadcrumb": [],
        "displayFallbackLanguageContent": false,
        "h1Length": 9,
        "items": [{
          "name": "12 Best City Break Hotels",
          "targetUrl": "/go/uk/best-city-break-hotels?intlid=gghome|trend",
          "snippetText": "City breaks are a great way to explore new destinations and experience different cultures. There are many fantastic hotels to choose from, depending on your preferences and budget. If you're looking for luxury and high-end service, there are many...",
          "parentPageId": "ad897c5b-9e6a-4710-a4cc-49b339d49cf2",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production58/d1753/c46fb367-cec6-4ab2-89a2-30361c465515.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best City Hotels Near Iconic Attractions",
          "targetUrl": "/go/uk/best-hotels-near-attractions-uk?intlid=gghome|trend",
          "snippetText": "If your hotel is surrounded by attractions and popular landmarks, it makes your city break more enjoyable and convenient. Not...",
          "parentPageId": "2fac2fec-f4dc-4e3b-9567-30cde698219a",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production49/d959/3507c101-6c84-43fe-aa0c-72435ecf215d.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "11 Best Beaches in England",
          "targetUrl": "/go/england/best-beaches-england?intlid=gghome|trend",
          "snippetText": "England is blessed with thousands of miles of coastline and hundreds of beaches. The best beaches in England are comprised...",
          "parentPageId": "c2acb7ba-5eda-4d9f-8208-fc547232cbf2",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production41/d471/054515c1-cd43-4e14-8c47-f32219278161.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Salou",
          "targetUrl": "/go/spain/best-things-to-do-salou?intlid=gghome|trend",
          "snippetText": "Salou is set on the beautiful Costa Daurada, known for its calm turquoise waters and long golden beaches. A lively...",
          "parentPageId": "d1edec52-13c4-4df4-9df4-e9d6fb69fc74",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production23/d1147/73209dc7-4e29-4a1c-947c-39bc49da7037.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "12 Best Things to Do in Edinburgh",
          "targetUrl": "/go/scotland/best-things-to-do-edinburgh?intlid=gghome|trend",
          "snippetText": "The list of the best things to do in Edinburgh generally starts with enjoying the city’s remarkable sights. The stunning...",
          "parentPageId": "3a737a2d-fdbf-43b4-b757-9e89545cf2a9",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production73/d1723/35b8f7e3-14c4-4d53-ae2f-5f7f6adb6aac.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "11 Surprisingly Affordable Luxury Hotels",
          "targetUrl": "/go/world/surprisingly-affordable-luxury-hotels?intlid=gghome|trend",
          "snippetText": "Our list of surprisingly affordable luxury hotels showcases some really amazing places you can stay for astonishingly little. Regardless of...",
          "parentPageId": "9d1ef322-ba68-4109-89fc-4d19c7b95bb3",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production167/d471/a62b633b-29cb-4d6f-96b8-ce1e31609a60.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "8 Best Cyprus Towns and Resorts",
          "targetUrl": "/go/cyprus/best-towns-resorts-cyprus?intlid=gghome|trend",
          "snippetText": "The best towns and resorts in Cyprus are quite a varied assortment, with a few highlights that rank among Europe's...",
          "parentPageId": "06df6dcc-8433-407d-8454-c26c475e7841",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production8/d938/57e2fbb3-bf97-4ec3-a6e8-c370e5b42ac5.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Canterbury",
          "targetUrl": "/go/england/best-things-to-do-canterbury?intlid=gghome|trend",
          "snippetText": "Canterbury is famed for its splendid cathedral and atmospheric medieval streets. A lively and multinational student population adds a more...",
          "parentPageId": "d1238c03-e4f8-41c4-ab8f-b151e7e470e7",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production132/d1495/1b3743a9-5890-4d5c-a087-bc814dc5014f.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Most Picturesque Villages in Kent",
          "targetUrl": "/go/england/most-picturesque-villages-kent?intlid=gghome|trend",
          "snippetText": "Kent is a historic county in southeast England that has long been touted as the “Garden of England.” With its...",
          "parentPageId": "2b4a3e96-7f0d-46d5-86a6-940471494ee2",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production158/d812/0464ffe1-5c9e-46f1-a9d2-eb47a3f58a8b.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Llandudno",
          "targetUrl": "/go/wales/things-to-do-llandudno?intlid=gghome|trend",
          "snippetText": "The best things to do in Llandudno often attract a crowd of beachgoers during the summer months. The town's seaside...",
          "parentPageId": "5522b876-cfbf-45f5-869e-9a211f6a8045",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production29/d701/4312989b-986d-43bc-9853-b2216dea5d05.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Weekend Breaks in the UK",
          "targetUrl": "/go/uk/best-weekend-breaks-uk?intlid=gghome|trend",
          "snippetText": "The best weekend breaks in the UK feature some of the country’s most popular cities, with a variety of noteworthy...",
          "parentPageId": "c6580aac-de24-427a-8d0e-ea8790400fc1",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production166/d1980/c54fa1eb-98fa-490d-b3ae-eb003e2456da.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Alicante",
          "targetUrl": "/go/spain/best-things-to-do-alicante?intlid=gghome|trend",
          "snippetText": "The best things to do in Alicante start with its expansive public beaches, where you can enjoy sailing, sunbathing, and...",
          "parentPageId": "069e6222-5da8-4de0-a8c4-a5f00709706d",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production44/d59/0379c1f0-db83-11e8-8d08-0242ac110002.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "13 Most Charming Towns and Villages in Yorkshire",
          "targetUrl": "/go/england/most-charming-towns-villages-yorkshire?intlid=gghome|trend",
          "snippetText": "Keeping a list of the most charming towns and villages in Yorkshire to a reasonable number is certainly a challenge...",
          "parentPageId": "52c9f9e4-b3fc-4be3-8c30-a0fda634f727",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production8/d1222/80656952-fd07-4929-abc0-91c9ba7348f7.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Beach Hotels in Europe ",
          "targetUrl": "/go/uk/best-beach-hotels-europe?intlid=gghome|trend",
          "snippetText": "Our list of the best beach hotels in Europe highlights some of the sun-soaked seaside resorts you’ll find towards...",
          "parentPageId": "a0308506-2964-443b-9be9-b8437b357d17",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production90/d637/796a4b18-41a0-4cdc-82b5-fae8c761d3e9.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "12 Most Picturesque Villages in Wales",
          "targetUrl": "/go/wales/most-picturesque-villages-wales?intlid=gghome|trend",
          "snippetText": "Wales is a land steeped in myth and folklore with picturesque villages to explore. From the mist-haloed mountains of...",
          "parentPageId": "161a5249-c895-4704-8e1d-834f87ee7d3d",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production182/d385/1b3ada49-a0d6-48ab-8d7e-2d757cb54ea1.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Malaga",
          "targetUrl": "/go/spain/best-things-to-do-malaga?intlid=gghome|trend",
          "snippetText": "This guide to the best things to do in Malaga is a mix of manmade and natural attractions, all of...",
          "parentPageId": "b323a9be-1723-413b-b178-1da0e011bd4c",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production190/d914/d78e1050-607d-4139-b764-89fc40e4d1c7.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "9 Mistakes People Make When Visiting the Canary Islands",
          "targetUrl": "/go/spain/mistakes-when-visiting-canary-islands?intlid=gghome|trend",
          "snippetText": "These mistakes people make when visiting the Canary Islands can put a damper on your tropical getaway. Like most tourist...",
          "parentPageId": "8a93aefb-2104-4f36-86e5-f1a24ef97ab8",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production157/d775/397b96ee-f5d3-4df1-b03a-8cca83fb84fe.jpg",
            "imageAttribution": null
          }
        }, {
          "name": "10 Best Things to Do in Torremolinos",
          "targetUrl": "/go/spain/best-things-to-do-torremolinos?intlid=gghome|trend",
          "snippetText": "The list of things to do in Torremolinos goes well beyond its popular beaches. The Mediterranean resort town in southern...",
          "parentPageId": "d06a8097-9d25-46cf-97b2-386ae34a1363",
          "createdDate": null,
          "image": {
            "imageUrl": "https://a.cdn-hotels.com/gdcs/production191/d926/a2dd42b4-f447-4c9e-b5f0-fa25915cd656.jpg",
            "imageAttribution": null
          }
        }],
        "destinationList": {
          "continents": [{
            "name": "Africa",
            "targetUrl": "/go/africa?intlid=gghome|keepexp",
            "countries": [{
              "name": "Seychelles",
              "targetUrl": "/go/seychelles?intlid=gghome|keepexp"
            }, {
              "name": "South Africa",
              "targetUrl": "/go/south-africa?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Asia",
            "targetUrl": "/go/asia?intlid=gghome|keepexp",
            "countries": [{
              "name": "Cambodia",
              "targetUrl": "/go/cambodia?intlid=gghome|keepexp"
            }, {
              "name": "China",
              "targetUrl": "/go/china?intlid=gghome|keepexp"
            }, {
              "name": "Hong Kong SAR",
              "targetUrl": "/go/hong-kong?intlid=gghome|keepexp"
            }, {
              "name": "Indonesia",
              "targetUrl": "/go/indonesia?intlid=gghome|keepexp"
            }, {
              "name": "Japan",
              "targetUrl": "/go/japan?intlid=gghome|keepexp"
            }, {
              "name": "Laos",
              "targetUrl": "/go/laos?intlid=gghome|keepexp"
            }, {
              "name": "Malaysia",
              "targetUrl": "/go/malaysia?intlid=gghome|keepexp"
            }, {
              "name": "Philippines",
              "targetUrl": "/go/philippines?intlid=gghome|keepexp"
            }, {
              "name": "Singapore",
              "targetUrl": "/go/singapore?intlid=gghome|keepexp"
            }, {
              "name": "South Korea",
              "targetUrl": "/go/south-korea?intlid=gghome|keepexp"
            }, {
              "name": "Taiwan",
              "targetUrl": "/go/taiwan?intlid=gghome|keepexp"
            }, {
              "name": "Thailand",
              "targetUrl": "/go/thailand?intlid=gghome|keepexp"
            }, {
              "name": "Vietnam",
              "targetUrl": "/go/vietnam?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Australia - New Zealand and the South Pacific",
            "targetUrl": "/go/oceania?intlid=gghome|keepexp",
            "countries": [{
              "name": "Australia",
              "targetUrl": "/go/australia?intlid=gghome|keepexp"
            }, {
              "name": "Fiji",
              "targetUrl": "/go/fiji?intlid=gghome|keepexp"
            }, {
              "name": "Guam",
              "targetUrl": "/go/guam?intlid=gghome|keepexp"
            }, {
              "name": "New Zealand",
              "targetUrl": "/go/new-zealand?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Caribbean",
            "targetUrl": "/go/caribbean?intlid=gghome|keepexp",
            "countries": [{
              "name": "Antigua and Barbuda",
              "targetUrl": "/go/antigua-and-barbuda?intlid=gghome|keepexp"
            }, {
              "name": "Aruba",
              "targetUrl": "/go/aruba?intlid=gghome|keepexp"
            }, {
              "name": "Bahamas",
              "targetUrl": "/go/bahamas?intlid=gghome|keepexp"
            }, {
              "name": "Barbados",
              "targetUrl": "/go/barbados?intlid=gghome|keepexp"
            }, {
              "name": "Bermuda",
              "targetUrl": "/go/bermuda?intlid=gghome|keepexp"
            }, {
              "name": "British Virgin Islands",
              "targetUrl": "/go/british-virgin-islands?intlid=gghome|keepexp"
            }, {
              "name": "Cayman Islands",
              "targetUrl": "/go/cayman-islands?intlid=gghome|keepexp"
            }, {
              "name": "Curaçao",
              "targetUrl": "/go/curacao?intlid=gghome|keepexp"
            }, {
              "name": "Dominican Republic",
              "targetUrl": "/go/dominican-republic?intlid=gghome|keepexp"
            }, {
              "name": "Jamaica",
              "targetUrl": "/go/jamaica?intlid=gghome|keepexp"
            }, {
              "name": "Martinique",
              "targetUrl": "/go/martinique?intlid=gghome|keepexp"
            }, {
              "name": "Puerto Rico",
              "targetUrl": "/go/puerto-rico?intlid=gghome|keepexp"
            }, {
              "name": "Saint Martin",
              "targetUrl": "/go/saint-martin?intlid=gghome|keepexp"
            }, {
              "name": "St. Kitts and Nevis",
              "targetUrl": "/go/st-kitts-and-nevis?intlid=gghome|keepexp"
            }, {
              "name": "St. Lucia",
              "targetUrl": "/go/st-lucia?intlid=gghome|keepexp"
            }, {
              "name": "Turks and Caicos",
              "targetUrl": "/go/turks-and-caicos?intlid=gghome|keepexp"
            }, {
              "name": "U.S. Virgin Islands",
              "targetUrl": "/go/us-virgin-islands?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Europe",
            "targetUrl": "/go/europe?intlid=gghome|keepexp",
            "countries": [{
              "name": "Austria",
              "targetUrl": "/go/austria?intlid=gghome|keepexp"
            }, {
              "name": "Belgium",
              "targetUrl": "/go/belgium?intlid=gghome|keepexp"
            }, {
              "name": "Bosnia and Herzegovina",
              "targetUrl": "/go/bosnia-and-herzegovina?intlid=gghome|keepexp"
            }, {
              "name": "Bulgaria",
              "targetUrl": "/go/bulgaria?intlid=gghome|keepexp"
            }, {
              "name": "Croatia",
              "targetUrl": "/go/croatia?intlid=gghome|keepexp"
            }, {
              "name": "Cyprus",
              "targetUrl": "/go/cyprus?intlid=gghome|keepexp"
            }, {
              "name": "Czechia",
              "targetUrl": "/go/czech-republic?intlid=gghome|keepexp"
            }, {
              "name": "Denmark",
              "targetUrl": "/go/denmark?intlid=gghome|keepexp"
            }, {
              "name": "England",
              "targetUrl": "/go/england?intlid=gghome|keepexp"
            }, {
              "name": "Estonia",
              "targetUrl": "/go/estonia?intlid=gghome|keepexp"
            }, {
              "name": "Finland",
              "targetUrl": "/go/finland?intlid=gghome|keepexp"
            }, {
              "name": "France",
              "targetUrl": "/go/france?intlid=gghome|keepexp"
            }, {
              "name": "Germany",
              "targetUrl": "/go/germany?intlid=gghome|keepexp"
            }, {
              "name": "Greece",
              "targetUrl": "/go/greece?intlid=gghome|keepexp"
            }, {
              "name": "Hungary",
              "targetUrl": "/go/hungary?intlid=gghome|keepexp"
            }, {
              "name": "Iceland",
              "targetUrl": "/go/iceland?intlid=gghome|keepexp"
            }, {
              "name": "Ireland",
              "targetUrl": "/go/ireland?intlid=gghome|keepexp"
            }, {
              "name": "Italy",
              "targetUrl": "/go/italy?intlid=gghome|keepexp"
            }, {
              "name": "Latvia",
              "targetUrl": "/go/latvia?intlid=gghome|keepexp"
            }, {
              "name": "Malta",
              "targetUrl": "/go/malta?intlid=gghome|keepexp"
            }, {
              "name": "Monaco",
              "targetUrl": "/go/monaco?intlid=gghome|keepexp"
            }, {
              "name": "Montenegro",
              "targetUrl": "/go/montenegro?intlid=gghome|keepexp"
            }, {
              "name": "Netherlands",
              "targetUrl": "/go/netherlands?intlid=gghome|keepexp"
            }, {
              "name": "Northern Ireland",
              "targetUrl": "/go/northern-ireland?intlid=gghome|keepexp"
            }, {
              "name": "Norway",
              "targetUrl": "/go/norway?intlid=gghome|keepexp"
            }, {
              "name": "Poland",
              "targetUrl": "/go/poland?intlid=gghome|keepexp"
            }, {
              "name": "Portugal",
              "targetUrl": "/go/portugal?intlid=gghome|keepexp"
            }, {
              "name": "Russia",
              "targetUrl": "/go/russia?intlid=gghome|keepexp"
            }, {
              "name": "Scotland",
              "targetUrl": "/go/scotland?intlid=gghome|keepexp"
            }, {
              "name": "Serbia",
              "targetUrl": "/go/serbia?intlid=gghome|keepexp"
            }, {
              "name": "Slovakia",
              "targetUrl": "/go/slovakia?intlid=gghome|keepexp"
            }, {
              "name": "Slovenia",
              "targetUrl": "/go/slovenia?intlid=gghome|keepexp"
            }, {
              "name": "Spain",
              "targetUrl": "/go/spain?intlid=gghome|keepexp"
            }, {
              "name": "Sweden",
              "targetUrl": "/go/sweden?intlid=gghome|keepexp"
            }, {
              "name": "Switzerland",
              "targetUrl": "/go/switzerland?intlid=gghome|keepexp"
            }, {
              "name": "Türkiye",
              "targetUrl": "/go/turkey?intlid=gghome|keepexp"
            }, {
              "name": "United Kingdom",
              "targetUrl": "/go/uk?intlid=gghome|keepexp"
            }, {
              "name": "Wales",
              "targetUrl": "/go/wales?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Mexico and Central America",
            "targetUrl": "/go/mexico-central-america?intlid=gghome|keepexp",
            "countries": [{
              "name": "Mexico",
              "targetUrl": "/go/mexico?intlid=gghome|keepexp"
            }]
          }, {
            "name": "Middle East",
            "targetUrl": "/go/middle-east?intlid=gghome|keepexp",
            "countries": [{
              "name": "Israel",
              "targetUrl": "/go/israel?intlid=gghome|keepexp"
            }, {
              "name": "Qatar",
              "targetUrl": "/go/qatar?intlid=gghome|keepexp"
            }, {
              "name": "United Arab Emirates",
              "targetUrl": "/go/united-arab-emirates?intlid=gghome|keepexp"
            }]
          }, {
            "name": "North America",
            "targetUrl": "/go/north-america?intlid=gghome|keepexp",
            "countries": [{
              "name": "Canada",
              "targetUrl": "/go/canada?intlid=gghome|keepexp"
            }, {
              "name": "United States of America",
              "targetUrl": "/go/usa?intlid=gghome|keepexp"
            }]
          }, {
            "name": "South America",
            "targetUrl": "/go/south-america?intlid=gghome|keepexp",
            "countries": [{
              "name": "Argentina",
              "targetUrl": "/go/argentina?intlid=gghome|keepexp"
            }, {
              "name": "Brazil",
              "targetUrl": "/go/brazil?intlid=gghome|keepexp"
            }, {
              "name": "Chile",
              "targetUrl": "/go/chile?intlid=gghome|keepexp"
            }, {
              "name": "Peru",
              "targetUrl": "/go/peru?intlid=gghome|keepexp"
            }]
          }]
        },
        "query": {
          "label": "Start planning your trip",
          "destination": null,
          "dates": null,
          "l10nDateFormat": {
            "defaultFormat": "dd/MM/yyyy",
            "firstDayOfWeek": 1,
            "l10nFormat": "dd/mm/yyyy",
            "l10nFormatFull": "{EEE} {d} {MMMM} {yyyy}",
            "monthNames": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "shortWeekDayNames": ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            "weekDayNames": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
          },
          "rooms": {
            "selected": [{
              "adults": 2,
              "children": []
            }]
          },
          "filter": {},
          "compactOccupancy": [{
            "adults": 1,
            "rooms": 1,
            "selected": false
          }, {
            "adults": 2,
            "rooms": 1,
            "selected": true
          }],
          "sort": {},
          "options": {
            "dateCheckboxOnPopup": false,
            "ctaLabelKey": "landing.qf.button.title.show_deals",
            "destinationLabelFirst": false,
            "displayInline": false,
            "dateCheckbox": false,
            "knownDestination": false
          },
          "savedSearch": false
        },
        "urlSlug": null,
        "omniture": {
          "urlSlug": null,
          "sitemapCountryName": "",
          "siteSection": "go guides :: home",
          "isRobot": "false",
          "pageCategory": "",
          "appName": "go guides",
          "regionName": "",
          "listicleGroup": "",
          "destinationId": "-1",
          "pageName": "go guides :: home",
          "platform": "",
          "pageLocation": "",
          "pageType": "Home",
          "cityName": "",
          "pageTypeTrackingName": "home",
          "destinationName": "",
          "destinationType": "",
          "countryName": "",
          "continentCode": ""
        }
      },
      "debug": {}
    }
  }
};